import titleReducer, { TitleState } from './title.reducer';
import { ClientFormState } from '../../types/client/client.def';
import { UserState } from '../../types/user/user.def';
import { combineReducers } from 'redux';
import quizReducer, { QuizState } from './quiz.reducer';
import createClasse, { CreateClasseState } from './createClasse.reducer';
import clientReducer from './client.reducer';
import productFilterReducer, {
  ProductFilterState
} from './productFilter.reducer';
import createLyceeReducer, { CreateLyceeState } from './createLycee.reducer';
import feedbackReducer, { FeedbackState } from './feedback.reducer';
import userReducer from './userState.reducer';
import { PanierState } from '../../types/panier/panier.def';
import panierReducer from './panierReducer';
import uiReducer, { UiState } from './ui.reducer';

export default combineReducers({
  title: titleReducer,
  quiz: quizReducer,
  client: clientReducer,
  productFilter: productFilterReducer,
  createClasse,
  createLycee: createLyceeReducer,
  feedback: feedbackReducer,
  user: userReducer,
  panier: panierReducer,
  ui: uiReducer
});

export interface AppState {
  title: TitleState;
  quiz: QuizState;
  client: ClientFormState;
  productFilter: ProductFilterState;
  createClasse: CreateClasseState;
  createLycee: CreateLyceeState;
  feedback: FeedbackState;
  user: UserState;
  panier: PanierState;
  ui: UiState;
}
